import { axios } from '../utilities';

const getDataForUserQuestionnaire = userId => axios.get(`api/questionnaires/customer/${userId}`);

const updateQuestionnaireByCustomer = (
  questionnaireId,
  customerId,
  questionnaireSections,
  shouldSubmit,
) => axios.put(
  `api/questionnaires/${questionnaireId}/update-by-customer`,
  {
    customerId,
    questionnaireSections,
    shouldSubmit,
  },
);

const getQuestionnaireByProjectId = projectId => axios.get(`api/questionnaires/projectId/${projectId}`);

const createQuestionnaire = (projectId, questionnaire) => axios.post(`api/questionnaires/${projectId}`, { questionnaire });

export default {
  getDataForUserQuestionnaire,
  updateQuestionnaireByCustomer,
  getQuestionnaireByProjectId,
  createQuestionnaire,
};
